import { FocusModeContext } from '@/contexts/focus-mode.context'
import { useContext } from 'react'

interface UseFocusModeReturn {
  isFocusMode: boolean
  toggleFocusMode: () => void
  enterFocusMode: () => void
  exitFocusMode: () => void
}

/**
 * Hook to manage focus/fullscreen mode for distraction-free data entry
 * - Hides sidebar and header when active
 * - Keyboard shortcuts: F11 to toggle, Escape to exit
 * - Uses shared context so all components see the same state
 */
export const useFocusMode = (): UseFocusModeReturn => {
  const context = useContext(FocusModeContext)

  if (!context) throw new Error('useFocusMode must be used within a FocusModeProvider')

  return context
}

export default useFocusMode
